// A paid single-bottle guide must never remain charged when the 2+ gift is included.
if (!customElements.get('steadia-muscle-guide')) {
  customElements.define('steadia-muscle-guide', class extends HTMLElement {
    connectedCallback() {
      window.SteadiaCart?.bindForm(this);
      this.reconcile = async () => {
        if (!this.isConnected || !this.dataset.includedLine || this.removing) return;
        // On /cart the footer owns reconciliation and refreshes the whole page.
        if (this.closest('cart-drawer') && document.querySelector('cart-items')) return;
        if (window.SteadiaCart?.busy) return;
        this.removing = true;
        const values = { id: this.dataset.includedLine, quantity: 0 };
        try {
          if (this.closest('cart-drawer')) {
            await window.SteadiaCart.mutate(routes.cart_change_url, values, this);
          } else {
            const response = await fetch(routes.cart_change_url, {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(values),
            });
            if (!response.ok) throw new Error('Please try again. The guide could not be updated.');
            window.location.reload();
          }
        } catch (error) {
          const message = this.querySelector('[data-cart-action-error]');
          message.textContent = error.message;
          message.hidden = false;
        } finally { this.removing = false; }
      };
      document.addEventListener('steadia:cart-idle', this.reconcile);
      this.reconcile();
    }
    disconnectedCallback() { document.removeEventListener('steadia:cart-idle', this.reconcile); }
  });
}
